<template>
  <router-link class="schedule-list-item" tag="div" :to="'/schedule/view/' + data.s_id">
    <div class="wrapper">
      <div class="flex">
        <span class="schedule">{{ data.title }}</span>
        <span class="disabled">{{ $moment(data.start_time).format("M月D日") }}开课</span>
      </div>
      <div class="flex">
        <div>
          <StudentName v-if="data.student" v-bind="data.student" />
          <StudentName
            v-else-if="user.student_name"
            :name_full="user.student_name + ' ' + user.student_name_eng"
            :gender="user.gender"
          />
        </div>
        <Teacher v-if="data.teacher.length" :teacher="data.teacher" />
      </div>
    </div>
  </router-link>
</template>

<script>
import Teacher from "./Teacher"
import StudentName from "@/components/public/StudentName"

export default {
  name: "ScheduleListItem",
  props: ["data"],
  components: {
    Teacher,
    StudentName
  },
  computed: {
    user() {
      return this.$store.state.user
    }
  },
  data() {
    return {}
  },
}
</script>
<style scoped lang="scss">
@import "./style.scss";
.schedule-list-item {
  padding: 13px 5%;
  margin: 15px auto 0 auto;
  box-shadow: $deep-shadow;
  transition: all 0.1s;
  border: $border;
  background: white;
  border-radius: 4px;
  &:active {
    opacity: 0.6;
  }

  .schedule {
    @include avenir-demi();
  }
}
</style>
